import { apiHelper } from "./core";

const baseUrl = process.env.REACT_APP_BASE_URL;

const getTestFindings = (body: any): Promise<any> => {
  const url: any = `${baseUrl}/ai/reports/`;
  return apiHelper
    .post(url, body)
    .then((res) => {
      return res?.data;
    })
    .catch((err) => Promise.reject(err));
};

const checkTestFindings = (fileId: string): Promise<any> => {
  const url: any = `${baseUrl}/ai/reports/${fileId}/`;
  return apiHelper
    .get(url)
    .then((res) => {
      return res?.data;
    })
    .catch((err) => Promise.reject(err));
};

const submitTestFeedback = (
  requestId: number,
  feedbackData: {
    verdict: "THUMBS_UP" | "THUMBS_DOWN";
    comment?: string;
    feedback_user_id?: string;
  }
): Promise<any> => {
  const url = `${baseUrl}/ai/reports/${requestId}/feedback/`;
  return apiHelper
    .post(url, feedbackData)
    .then((res) => {
      return res?.data;
    })
    .catch((err) => Promise.reject(err));
};

const createTranscription = (body: {
  audio_file: string;
  title?: string;
  doctor_name?: string;
  patient_id?: string | number;
  patient_name?: string;
  triggered_by_user_id?: string | number;
}): Promise<any> => {
  const url: any = `${baseUrl}/ai/transcription/`;
  return apiHelper
    .post(url, body)
    .then((res) => res?.data)
    .catch((err) => Promise.reject(err));
};
const getTranscriptionDetail = (id: number | string): Promise<any> => {
  const url: any = `${baseUrl}/ai/transcription/${id}/`;
  return apiHelper
    .get(url)
    .then((res) => res?.data)
    .catch((err) => Promise.reject(err));
};
export {
  getTestFindings,
  checkTestFindings,
  submitTestFeedback,
  createTranscription,
  getTranscriptionDetail,
};
